import { render, staticRenderFns } from "./FilterBarPopularProvider.vue?vue&type=template&id=23c64e12&scoped=true"
import script from "./FilterBarPopularProvider.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterBarPopularProvider.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterBarPopularProvider.vue?vue&type=style&index=0&id=23c64e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c64e12",
  null
  
)

export default component.exports